import { render } from "./mail-admin-header.vue?vue&type=template&id=f225ab50"
import script from "./mail-admin-header.vue?vue&type=script&lang=js"
export * from "./mail-admin-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__